// src/components/charts/DemoTrendChart.jsx
import React, { memo } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from "chart.js";
import { MinMaxBarsPlugin } from "../../utils/plugins/minMaxBars";
import { getPrimaryColour } from "../../utils/getPrimaryColour";

// Minimal registration
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  MinMaxBarsPlugin
);

function DemoTrendChart({ height = 240 }) {
  // Fixed demo labels & values: recovery improving over time
  const labels = ["May", "Jun", "Jul", "Aug", "Sep", "Oct"];

  // Average values trending upward (e.g. better recovery score)
  const avgValues = [0.62, 0.61, 0.69, 0.68, 0.75, 0.79];

  // Min–max per label for the bars (narrowing variability is optional but nice)
  const minMax = [
    { min: 0.6, max: 0.65 },
    { min: 0.59, max: 0.63 },
    { min: 0.63, max: 0.75 },
    { min: 0.67, max: 0.7 },
    { min: 0.71, max: 0.8 },
    { min: 0.77, max: 0.81 },
  ];

  const chartData = {
    labels,
    datasets: [
      {
        label: "Recovery",
        data: avgValues,
        borderColor: getPrimaryColour(), // typography-ish
        pointBackgroundColor: getPrimaryColour(), // primary
        pointBorderColor: getPrimaryColour(),
        pointRadius: 3,
        pointHoverRadius: 3,
        borderWidth: 2,
        tension: 0.25, // slight smoothing
        spanGaps: true,
        _minMax: minMax, // consumed by MinMaxBarsPlugin
      },
    ],
  };

  // Compute y-bounds with a touch of padding
  const all = [
    ...avgValues,
    ...minMax.map((m) => m.min),
    ...minMax.map((m) => m.max),
  ];
  const yMin = Math.min(...all);
  const yMax = Math.max(...all);
  const pad = (yMax - yMin || 1) * 0.08;

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    // Zero interactivity
    events: [],
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
      title: { display: false },
      // Min–max bar style (behind the line)
      minMaxBars: {
        lineWidth: 10, // bar thickness
        color: getPrimaryColour(), // primary with transparency
        capStyle: "round", // if your plugin supports it
      },
    },

    // Clean: no axis titles, ticks, or grid
    scales: {
      x: {
        grid: { display: false, drawBorder: false },
        border: { display: false },
        ticks: { display: false },
        title: { display: false },
      },
      y: {
        grid: { display: false, drawBorder: false },
        border: { display: false },
        min: yMin - pad,
        max: yMax + pad,
        grid: { display: false, drawBorder: false },
        ticks: { display: false },
        title: { display: false },
      },
    },

    // Disable animations if you want it totally static
    animation: { duration: 600 },
  };

  return (
    <div className="relative" style={{ height }}>
      <Line data={chartData} options={options} />
    </div>
  );
}

export default memo(DemoTrendChart);
